import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Areas of Focus", to: "/areas-of-focus" },
  { label: "Events", to: "/events" },
  { label: "Publications", to: "/publications" },
  { label: "Advisory Board", to: "/advisory-board" },
  { label: "Contact", to: "/contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 bg-amf-navy text-amf-cream transition-shadow ${
        scrolled ? "shadow-md" : ""
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-[68px]">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group shrink-0 mr-8">
            <img
              src="/board/logo-circle.png"
              alt="Asana Memorial Foundation logo"
              className="h-11 w-11 rounded-full object-cover"
            />
            <span className="font-playfair text-lg lg:text-xl xl:text-2xl tracking-wide text-amf-cream whitespace-nowrap">
              Asana Memorial
            </span>
          </Link>

          <nav className="hidden xl:flex items-center gap-6">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `amf-overline whitespace-nowrap transition-colors hover:text-amf-gold ${
                    isActive ? "text-amf-gold" : "text-amf-cream/90"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              data-testid="nav-donate-button"
              className="amf-overline bg-amf-burgundy text-amf-cream px-5 py-2.5 hover:bg-[#c24e12] transition-colors"
            >
              Donate
            </Link>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="xl:hidden text-amf-cream"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle navigation"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="xl:hidden border-t border-amf-gold/20 bg-amf-navy">
          <nav className="flex flex-col px-6 py-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `amf-overline py-3 border-b border-amf-cream/10 hover:text-amf-gold ${
                    isActive ? "text-amf-gold" : "text-amf-cream/90"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              className="amf-overline bg-amf-burgundy text-amf-cream text-center px-5 py-3 mt-4"
            >
              Donate
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
